import { StoreOptions, ActionContext } from 'vuex';
import createLogger from 'vuex/dist/logger';
import { IAppRootState } from './IAppRootState';
import { TjipVuexAction, TjipVuexModule, TjipVuexPlugin } from '@tjip/vuejs';
import * as _ from 'lodash';
import { AppHypothekenDataModule } from './AppHypothekenDataModule';
import { AppAflosschemasDataModule } from './AppAflosschemasDataModule';
import { AppBerichtenDataModule } from './AppBerichtenDataModule';
import { AppConfigDataModule } from './AppConfigDataModule';
import { AppGebruikerDataModule } from './AppGebruikerDataModule';
import { AppSettingsDataModule } from './AppSettingsDataModule';
import { AppSessionSuspendedDataModule } from './AppSessionSuspendedDataModule';

export class AppRootStore implements StoreOptions<IAppRootState> {
  state: IAppRootState = {};

  @TjipVuexModule
  private config() {
    return new AppConfigDataModule();
  }

  @TjipVuexModule
  private hypotheken() {
    return new AppHypothekenDataModule();
  }

  @TjipVuexModule
  private berichten() {
    return new AppBerichtenDataModule();
  }

  @TjipVuexModule
  private gebruiker() {
    return new AppGebruikerDataModule();
  }

  @TjipVuexModule
  private settings() {
    return new AppSettingsDataModule();
  }

  @TjipVuexModule
  private sessionSuspended() {
    return new AppSessionSuspendedDataModule();
  }

  @TjipVuexModule
  private aflosschemas() {
    return new AppAflosschemasDataModule();
  }

  @TjipVuexAction
  private init(ctx: ActionContext<IAppRootState, IAppRootState>): Promise<any[]> {
    return AppRootStore.dispatchModuleAction.call(this, ctx, 'init');
  }

  @TjipVuexAction
  private logout(ctx: ActionContext<IAppRootState, IAppRootState>): Promise<any[]> {
    return AppRootStore.dispatchModuleAction.call(this, ctx, 'logout');
  }

  private static dispatchModuleAction(
    ctx: ActionContext<IAppRootState, IAppRootState>,
    action: string
  ): Promise<any[]> {
    const modules = (this as any)._modules.root._children;
    const promises: Promise<any>[] = [];
    _.forEach(Object.keys(modules), (key: string) => {
      promises.push(ctx.dispatch(`${key}/${action}`));
    });
    return Promise.all(promises);
  }

  @TjipVuexPlugin
  private logger() {
    return process.env.NODE_ENV === 'production' ? undefined : createLogger();
  }
}
